import { defineMessages } from 'react-intl';

export default defineMessages({
  tableTitle: {
    id: 'miscellaneousAccounting.tableTitle',
    defaultMessage: 'Miscellaneous Accounting',
  },
  emptyStateMessage: {
    id: 'miscellaneousAccounting.emptyStateMessage',
    defaultMessage: 'No items found',
  },
  status: {
    id: 'miscellaneousAccounting.status',
    defaultMessage: 'Status',
  },
  miscRequestType: {
    id: 'miscellaneousAccounting.miscRequestType',
    defaultMessage: 'Misc. Request Type',
  },
  comments: {
    id: 'miscellaneousAccounting.comments',
    defaultMessage: 'Comments',
  },
  requestedAmount: {
    id: 'miscellaneousAccounting.requestedAmount',
    defaultMessage: 'Requested Amount',
  },
  approvedAmount: {
    id: 'miscellaneousAccounting.approvedAmount',
    defaultMessage: 'Approved Amount',
  },
  chargeCode: {
    id: 'miscellaneousAccounting.chargeCode',
    defaultMessage: 'Charge Code',
  },
  actions: {
    id: 'miscellaneousAccounting.actions',
    defaultMessage: 'Actions',
  },
  addNew: {
    id: 'miscellaneousAccounting.addNew',
    defaultMessage: 'Add New',
  },
  delete: {
    id: 'miscellaneousAccounting.delete',
    defaultMessage: 'Delete',
  },
  loadError: {
    id: 'miscellaneousAccounting.loadError',
    defaultMessage:
      'Failed to load Miscellaneous Accounting records. Please try again.',
  },
  loadChargeCodesError: {
    id: 'miscellaneousAccounting.loadChargeCodesError',
    defaultMessage: 'Failed to load charge codes. Please try again.',
  },
  createSuccess: {
    id: 'miscellaneousAccounting.createSuccess',
    defaultMessage: 'Miscellaneous Accounting record created successfully.',
  },
  createError: {
    id: 'miscellaneousAccounting.createError',
    defaultMessage:
      'Failed to create Miscellaneous Accounting record. Please try again.',
  },
  deleteSuccess: {
    id: 'miscellaneousAccounting.deleteSuccess',
    defaultMessage: 'Miscellaneous Accounting record deleted successfully.',
  },
  deleteError: {
    id: 'miscellaneousAccounting.deleteError',
    defaultMessage:
      'Failed to delete Miscellaneous Accounting record. Please try again.',
  },
  voucherStatusUpdatedTitle: {
    id: 'miscellaneousAccounting.voucherStatusUpdatedTitle',
    defaultMessage: 'Voucher Status Updated',
  },
  voucherReturnedToDraftWarning: {
    id: 'miscellaneousAccounting.voucherReturnedToDraftWarning',
    defaultMessage:
      'The voucher has been returned to Draft status. A new submission will be required.',
  },
  deletePaidError: {
    id: 'miscellaneousAccounting.deletePaidError',
    defaultMessage:
      'Cannot delete misc accounting records from vouchers that have been paid.',
  },
  deleteNotFoundError: {
    id: 'miscellaneousAccounting.deleteNotFoundError',
    defaultMessage: 'Miscellaneous Accounting record not found.',
  },
  deleteFeatureUnavailableError: {
    id: 'miscellaneousAccounting.deleteFeatureUnavailableError',
    defaultMessage:
      'This feature is not available. Please contact your administrator.',
  },
  deleteMissingIdError: {
    id: 'miscellaneousAccounting.deleteMissingIdError',
    defaultMessage: 'Unable to delete: record ID is missing.',
  },
  updateApprovedAmountError: {
    id: 'miscellaneousAccounting.updateApprovedAmountError',
    defaultMessage: 'Unable to update approved amount. Please try again.',
  },
  updateApprovedAmountSuccess: {
    id: 'miscellaneousAccounting.updateApprovedAmountSuccess',
    defaultMessage: 'Approved amount updated successfully.',
  },
});
